import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { combineLatest, Observable, tap } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { filterBoolean } from '@recruitee/common';
import type { CountryRegion } from '@recruitee/locations-types';

import { RegionActions, RegionSelectors } from './regions.store';

@Injectable({ providedIn: 'root' })
export class RegionsStoreService {
  private _countryHasRegions = new Map<string, boolean>();

  constructor(private store: Store) {}

  public getOrLoadCountryRegions(countryCode: string): Observable<CountryRegion[]> {
    combineLatest([
      this.store.select(RegionSelectors.isPending(countryCode)),
      this.store.select(RegionSelectors.isLoaded(countryCode)),
      this.store.select(RegionSelectors.error(countryCode)),
    ])
      .pipe(first())
      .subscribe(([loading, loaded, error]) => {
        if ((loaded || loading) && !error) return;

        this.store.dispatch(RegionActions.fetchOne({ payload: { id: countryCode } }));
      });

    return this.store.select(RegionSelectors.byCountyCode(countryCode)).pipe(
      filterBoolean,
      tap(({ regions }) => {
        this._countryHasRegions.set(countryCode, regions.length > 0);
      }),
      map(({ regions }) => regions),
    );
  }
}
